import { LazyLoadImageProps } from 'react-lazy-load-image-component';
import classNames from 'classnames';
import { AvatarContainer, AvatarContainerProps } from '@components/avatar/AvatarContainer';
import { AvatarIcon } from '@components/avatar/AvatarIcon';
import { Grid } from '@components/grid';
import { Text } from '@components/text';
import { LazyLoadWrapper } from '@components/utils';
import KidsBadge from '../assets/kids-badge.svg';
import './ImageAvatar.scss';

export interface ImageAvatarProps extends AvatarContainerProps {
  alt?: string;
  /** Scale to 100% of the container width with a 1:1 aspect ratio; `size` caps max width at the
   * avatar size token. For use in carousels where slide width drives avatar size */
  fill?: boolean;
  kidsLabel?: string;
  isKids?: boolean;
  src?: string;
  lazy?: boolean;
  lazyProps?: LazyLoadImageProps;
}

export const ImageAvatar: React.FC<ImageAvatarProps> = ({
  alt,
  className: classNameFromProps,
  fill,
  isKids,
  kidsLabel,
  size = 'large',
  src,
  style,
  lazy,
  lazyProps,
  ...rest
}) => {
  const kidsBadge = (
    <Grid
      className="vds-image-avatar__kids-badge-container"
      gridTemplateColumns="1fr"
      gridTemplateRows="1fr">
      <Text className="vds-image-avatar__kids-label" variant="kids" color="primary" size={size}>
        {kidsLabel}
      </Text>
      <KidsBadge className="vds-image-avatar__kids-badge" />
    </Grid>
  );

  return (
    <AvatarContainer
      className={classNames(
        'vds-image-avatar',
        `vds-image-avatar--${size}`,
        fill && 'vds-image-avatar--fill',
        classNameFromProps,
      )}
      fill={fill}
      size={size}
      style={style}
      {...rest}>
      <LazyLoadWrapper
        alt={alt}
        src={src}
        lazy={lazy}
        lazyProps={lazyProps}
        fallback={
          <AvatarIcon className="vds-image-avatar__fallback-icon" name="person" aria-label={alt} />
        }
      />
      {isKids && kidsBadge}
    </AvatarContainer>
  );
};
